/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListingOtaSimulation } from '../models/ListingOtaSimulation';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ListingOtaSimulationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves a ListingOtaSimulation resource.
     * Retrieves a ListingOtaSimulation resource.
     * @param accommodationId
     * @param listingType
     * @param listingId
     * @param activeReservation
     * @param provision
     * @param conversion
     * @param accommodationMultiplier
     * @returns ListingOtaSimulation ListingOtaSimulation resource
     * @throws ApiError
     */
    public apiAccommodationslistingsimulationotaGet(
        accommodationId?: string,
        listingType?: string,
        listingId?: string,
        activeReservation?: number,
        provision?: number,
        conversion?: number,
        accommodationMultiplier?: number,
    ): CancelablePromise<ListingOtaSimulation> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/accommodations/listing/simulation/ota',
            query: {
                accommodationId: accommodationId,
                listingType: listingType,
                listingId: listingId,
                activeReservation: activeReservation,
                provision: provision,
                conversion: conversion,
                accommodationMultiplier: accommodationMultiplier,
            },
            errors: {
                400: `Bad request`,
                403: `Forbidden`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
